export enum USER_ROLE {
	ADMIN = 'ADMIN',
	MODERATOR = 'MODERATOR',
	WRITER = 'WRITER',
	SOURCER = 'SOURCER',
}
